import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Thumbnail from './Thumbnail';
import Arrow from './Arrow';
// const arrowStyles = {
//   height: theme.thumbnail.size + theme.thumbnail.gutter * 2,
//   width: 40,
// };

const PaginatedThumbnails = ({
  theme = {},
  leftTitle,
  rightTitle,
  currImg,
  imgs,
  offset,
  onClickThumbnail,
  ...props
}) => {
  const [hasCustomPage, setHasCustomPage] = useState(false);
  const [first, setFirst] = useState(0);

  const clampFirst = (value) => {
    const totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
    if (value < 0) {
      return 0;
    } else if (value + totalCount > imgs.length) {
      return imgs.length - totalCount;
    } else {
      return value;
    }
  };

  useEffect(() => {
    setHasCustomPage(false);
  }, [currImg]);

  const getFirst = useCallback(() => {
    return hasCustomPage ? clampFirst(first) : clampFirst(currImg - offset);
  }, [hasCustomPage, first, currImg, offset]);

  const setFirstPage = (event, newFirst) => {
    event?.preventDefault();
    event?.stopPropagation();

    if (first !== newFirst) {
      setHasCustomPage(true);
      setFirst(newFirst);
    }
  };

  const gotoPrev = (event) => setFirstPage(event, getFirst() - offset);
  const gotoNext = (event) => setFirstPage(event, getFirst() + offset);

  const renderArrowPrev = () => {
    if (getFirst() <= 0) return null;
    return (
      <Arrow
        theme={theme}
        direction="left"
        size="small"
        icon="arrowLeft"
        onClick={gotoPrev}
      />
    );
  };

  const renderArrowNext = () => {
    const totalCount = 2 * offset + 1;
    if (getFirst() + totalCount >= imgs.length) return null;
    return (
      <Arrow
        theme={theme}
        direction="right"
        size="small"
        icon="arrowRight"
        onClick={gotoNext}
      />
    );
  };

  const totalCount = 2 * offset + 1;
  let thumbnails = [];
  let baseOffset = 0;
  if (imgs.length <= totalCount) {
    thumbnails = imgs;
  } else {
    baseOffset = getFirst();
    thumbnails = imgs.slice(baseOffset, baseOffset + totalCount);
  }

  return (
    <div
      className="absolute left-1/2 transform -translate-x-1/2 bottom-[theme.container.gutter.vertical] h-[theme.thumbnail.size] py-0 px-12 text-center whitespace-nowrap"
      {...props}
    >
      {renderArrowPrev()}
      {thumbnails.map((img, idx) => (
        <Thumbnail
          theme={theme}
          key={baseOffset + idx}
          index={baseOffset + idx}
          onClick={onClickThumbnail}
          active={baseOffset + idx === currImg}
        />
      ))}
      {renderArrowNext()}
    </div>
  );
};

PaginatedThumbnails.propTypes = {
  theme: PropTypes.object,
  leftTitle: PropTypes.string,
  rightTitle: PropTypes.string,
  currImg: PropTypes.number,
  imgs: PropTypes.array,
  offset: PropTypes.number,
  onClickThumbnail: PropTypes.func.isRequired,
};

export default PaginatedThumbnails;
